<template>
  <div
    id="app"
    class="min-h-screen flex flex-col text-center"
  >
    <nav-component />
    <div class="transition-wrapper">
      <transition
        name="fade"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
      >
        <router-view key="$route.fullPath" />
      </transition>
    </div>
    <footer-component />
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue'
import AppFooter from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    'nav-component': TopNav,
    'footer-component': AppFooter
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 0
    },
    enter(el, done) {
      el.offsetHeight // Trigger reflow
      el.style.transition = 'opacity 1s ease'
      el.style.opacity = 1
      done()
    },
    leave(el, done) {
      el.style.transition = 'opacity 1s ease'
      el.style.opacity = 0
      done()
    }
  }
}
</script>

<style>
.transition-wrapper {
  position: relative;
  flex-grow: 1; /* Allow main content to grow and push footer down */
}

/* CSS for fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in Vue < 2.1.8 */ {
  opacity: 0;
}
</style>
